import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// 语言资源
const resources = {
  en: {
    translation: {
        note: "*The author's English is not good, so please forgive inaccuracies in the translation.",
        welcome: "Welcome to download squid desktop pet!",
        describe: "Please download the software according to your computer!",
        octodescribe: "",
        octodownload: "",
        author: "About the Author",
        about3: "Occasionally update some things I made.",
        about: "Bilibili: 丢丢1092",
        about2: "Red Note: 塔皮欧卡",
        entercode: "Please enter the redemption code",
        confirm: "Confirm",
        cancel: "Cancel",
        error: "Invalid redemption code, please try again!",
        contact: "If you encounter any problems, feel free to contact the author!",
        advertise: "If you could give my GitHub repo a star, I'll be as happy as a puppy~",
        wechat: "WeChat: ",
        alipay: "Alipay: ",
        donate: "Donate",
        thank: "Thank you for your support! Your encouragement is my greatest motivation!",
        code: "",
        close: "Close",
        wintip: "If a blue window pops up on Windows, click: More info -> Run anyway",
        notice: "*Your computer flags this as suspicious simply because the publisher is unknown",
        mactip: "MacOS version installation guide:",
        macsetting: "Privacy settings needed after running the squid software (for MacOS, required for wallpaper recognition):",
        littletip: "The macOS version has some feature limitations. For details, please refer to the user manual! The Mac version was co-developed and produced by Mr. gieり. Thank him very much for contribution!",
        historytip: "* These are previously released versions, divided into two apps: Little Squid and Little Octopus. They are more minimalistic with fewer features.",
        historyversion: "Welcome to the historical version downloads",
        historyinstruct: "Please download the appropriate software for your computer!",

        viewhistory: "View Historical Versions",
        squid_win: "squid(windows)",
        squid_mac: "squid(mac)",
        octo_win: "octo(windows)",
        octo_mac: "octo(mac)",
        congrats: "MacOS Squid Download",
        instruct: "Please download the version corresponding to your Mac's chip! (If it doesn't work, please try another one)",
        back: "Back",
        image: "/images/wechat.jpg",
        i1: "1. Drag the app icon to ",
        i2: "",
        i3: "2. Click the question mark in the top right when this window appears",
        i4: "3. Click \"Open General Settings for Me\"",
        i5: "4. Select \"Open Anyway\"",
        i6: "5. After completing the above steps, the software will be located in \"Finder -> Applications\". If you want the second interactive squid/octopus, copy the DMG file, and repeat the previous steps. This will create two copies of the software in the \"Applications\" folder.",
        i7: "6. Now you have it!",
        i8: "5. After completing the above steps, the software will be located in \"Finder -> Applications\".",
        s1: "1. After opening the app, select \"Open System Preferences\" when prompted",
        s2: "2. Click the lock icon at the bottom left to make changes",
        s3: "3. Enter your password (login password) to unlock",
        s4: "4. Click \"+\" to add the app and check the box",
        s5: "5. Select \"Later\", then restart the squid app",
        s6: "All set! Enjoy!",
        intel: "Intel Chip",
        apple: "Apple Chip"
        
    },
  },
  zh: {
    translation: {
      //note: "",
      note: "",
      welcome: "免费下载自制小鱿鱼桌宠！",
      describe: "请根据您的电脑来下载对应的软件吧！",
      octodescribe: "",
      octodownload: "",
      author: "关于作者",

      about3: "不定时更新一些自己做的玩意儿。",
      about: "b站：丢丢1092",
      about2: "小红书：塔皮欧卡",
      
      entercode: "请输入领取码",
      confirm: "确认",
      cancel: "取消",
      error: "领取码错误，请重新输入！",
      contact: "如果碰到任何问题欢迎联系作者！",
      advertise: "如果能给我的github一个star，我会开心成小狗~",
      wechat: "微信：",
      alipay: "支付宝：",
      donate: "打赏",
      thank: "感谢打赏，您的支持就是我最大的动力！",
      code: "",
      close: "关闭",
      wintip: "Windows上运行时如果弹出小蓝窗就点击：更多信息 -> 仍要运行 就行",
      notice: "*电脑会觉得这是可疑软件只是因为发布者未知而已",
      mactip: "下面是MacOS版安装小指导：",
      macsetting: "下面是运行小鱿鱼软件后需要进行的一些隐私设置（也是MacOS上的，不设置的话只能识别壁纸）：",
      littletip: "* MacOS版部分功能受限，具体请见说明书！Mac版由gieり老师协作开发+制作，苹果芯片版碰到了问题请去找他，非常感谢！（苹果芯片版功能更全）",
      historytip: "* 这里是上次发布过的版本，分成小鱿鱼和小章鱼两个软件，软件更简约功能更少",
      historyversion: "欢迎来到历史版本下载",
      historyinstruct: "请根据您的电脑下载对应的软件吧！",
      viewhistory: "查看历史版本",
      squid_win: "小鱿(windows)",
      squid_mac: "小鱿(mac)",
      octo_win: "小章(windows)",
      octo_mac: "小章(mac)",
      congrats: "MacOS版小鱿鱼下载",
      instruct: "请根据您的mac的芯片下载对应版本的软件吧！（如果运行不了请尝试另一个）",
      back: "返回",
      image: "/images/wechat.jpg", 
      i1: "1. 把软件图标拖到 ",
      i2: " 中",
      i3: "2. 弹出此窗口后点击右上方问号",
      i4: "3. 点击“为我打开通用面板”",
      i5: "4. 选择“仍要打开”",
      i6: "5. 完成以上步骤后软件会在“访达 -> 应用程序”，mac版打开第二只可互动小鱿/章请拷贝一份dmg并再按照之前的操作进行一遍，这样在“应用程序”中有两份此软件",
      i7: "6. 这样就拥有啦",
      i8: "5. 完成以上步骤后软件会在“访达 -> 应用程序”",
      s1: "1. 打开软件后会马上出现这样的提示，选择“打开系统偏好设置”",
      s2: "2. 点击左下角“点按锁按钮以进行更改",
      s3: "3. 输入密码（开机密码）以解锁",
      s4: "4. 点击“+”号添加此软件，并打勾",
      s5: "5. 选择“以后”之后关闭小鱿鱼再重新打开小鱿鱼就行",
      s6: "这样就完成啦，辛苦啦！祝玩得开心！",

      intel: "intel芯片",
      apple: "苹果芯片",
     
      
      
    },
  },
  jp: {
    translation: {
        
        note: "※ 作者は日本語が全くできませんので、翻訳に不正確な点がありましたらご容赦ください。 ",
        welcome: "自作のイカのデスクトップペットをダウンロードへようこそ！",
      describe: "お使いのコンピューターに合わせてソフトウェアをダウンロードしてください！",
      octodescribe: "",
      octodownload: "",
      author: "作者について",
      about3: "自作の作品を不定期で更新しています",
      about: "Bilibili: 丢丢1092",
      about2: "レッド: 塔皮欧卡",
      entercode: "引き換えコードを入力してください",
      confirm: "確認",
      cancel: "キャンセル",
      error: "コードが間違っています。再入力してください",
      contact: "問題が発生した場合は作者までご連絡ください",
      advertise: "もし私のGitHubにスターをくれれば、子犬のように嬉しくて飛び跳ねちゃうわ〜",
      wechat: "WeChat: ",
      alipay: "Alipay: ",
      donate: "寄付",
      thank: "ご支援ありがとうございます！皆様の応援が励みになります！",
      code: "",
      close: "閉じる",
      wintip: "Windowsで青いウィンドウが表示されたら「詳細情報」→「実行」を選択してください",
      notice: "*発行元が不明なため、コンピューターが疑わしいと判定しています",
      mactip: "MacOS版インストールガイド：",
      macsetting: "MacOS版実行後に必要なプライバシー設定（壁紙認識機能を使用する場合）：",
      historytip: "※ これは以前にリリースされたバージョンで、「小イカ」と「小タコ」という2つのアプリに分かれています。機能は少なく、よりシンプルです。",
      historyversion: "旧バージョンのダウンロードへようこそ",
      historyinstruct: "お使いのパソコンに合ったソフトをダウンロードしてください！",

      viewhistory: "過去のバージョンを見る"
,
      squid_win: "いか(windows)",
      squid_mac: "いか(mac)",
      octo_win: "たこ(windows)",
      octo_mac: "たこ(mac)",

      congrats: "MacOS版イカペットダウンロード",
      instruct: "お使いのMacのチップに合ったバージョンをダウンロードしてください（うまく動作しない場合は、別のものを試してください）",
      back: "戻る",
      image: "/images/wechat.jpg",
      i1: "1. アプリアイコンを ",
      i2: " にドラッグ",
      i3: "2. このウィンドウが表示されたら右上の？をクリック",
      i4: "3. 「一般設定を開く」を選択",
      i5: "4. 「とにかく開く」を選択",
      i6: "5. 上記の手順を完了すると、ソフトウェアは「Finder → アプリケーション」に配置されます。Mac版の場合、2つ目の操作可能なイカ/タコを開いたら、DMGファイルをコピーし、前述の操作をもう一度繰り返してください。これにより「アプリケーション」フォルダ内に当該ソフトウェアが2つ作成されます",
      i7: "6. これで完了です！",
      i8: "5. 上記の手順を完了すると、ソフトウェアは「Finder → アプリケーション」に配置されます。",
      s1: "1. アプリ起動後、「システム環境設定を開く」を選択",
      s2: "2. 左下の錠アイコンをクリック",
      s3: "3. パスワード（ログインパスワード）を入力",
      s4: "4. 「+」をクリックしアプリを追加してチェック",
      s5: "5. 「後で」を選択し、アプリを再起動",
      s6: "設定完了です！お楽しみください！",
      intel: "Intelチップ",
      apple: "Appleチップ"
    },
  },
};

// 初始化 i18next
i18n
  .use(LanguageDetector) // 检测用户语言
  .use(initReactI18next) 
  .init({
    resources,
    fallbackLng: "zh", // 默认语言
    interpolation: {
      escapeValue: false, 
    },
  });

export default i18n;
